import React from "react";
import "./IleGrouLeJeu.scss";
import IslandVideo from "../../components/ui/IslandVideo";

export default function IleGrouLeJeu() {
	return (
		<div id='ilegroulejeu' className='small_island'>
			<div className='video_container'>
				<IslandVideo
					webmSrc='/videos/iles/grou_le_jeu_VP9.webm'
					mp4Src='/videos/iles/grou_le_jeu-hevc-safari.mp4'
				/>
				{/* <img className='cover' src='/img/iles/groulejeu.webp' alt='' /> */}
			</div>
			<div className='text'>
				<h2 className='island_title'>
					Grou
					<span className='breakDown'>le jeu</span>
				</h2>
				<p>
					Grou en 8bit et en 2D? <br />
					Talatopé !
				</p>
			</div>
		</div>
	);
}
